import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import { SELF_PANEL_BUTTON_BACKGROUND_COLOR, SELF_PANEL_BUTTON_HOVER_COLOR, SELF_PANEL_CONTENT_BACKGROUND_COLOR } from '../../styles/colors';
export const AVATAR_PART_BUTTON_CSS = css `
  cursor: pointer;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: ${SELF_PANEL_BUTTON_BACKGROUND_COLOR};
  border-radius: 10px;
  border: 4px solid ${SELF_PANEL_CONTENT_BACKGROUND_COLOR};
  width: 150px;
  max-width: 100%;
  &:hover {
    background-color: ${SELF_PANEL_BUTTON_HOVER_COLOR};
  }
`;
const SELECTED_BUTTON_CSS = css(AVATAR_PART_BUTTON_CSS, css `
    border-color: ${color(SELF_PANEL_CONTENT_BACKGROUND_COLOR).mix(color('white'), 0.8).hex()};
  `);
export const AvatarPartButton = ({ isSelected, onClick, children }) => {
    return (_jsx("button", { css: isSelected ? SELECTED_BUTTON_CSS : AVATAR_PART_BUTTON_CSS, onClick: onClick, children: children }));
};
